(function($) {
    $(document).ready(function () {
        const location = $('.home #ihf-area-input');
        const propertySearch = $('.home #searchProfile fieldset >.row');
        const otherFields = $('.home #searchProfile fieldset >.row .col-xs-12:not(first)');
        const searchButton = $('.home #searchProfile fieldset >.row .col-xs-12:last-child .btn');

        location.on('click keypress', function() {
            if ($(window).width() < 1025) {
                otherFields.slideDown();
            }
        });
    });
})(jQuery, this);
